export function getSuffix(n) {
  var s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}



// WEBPACK FOOTER //
// ./src/shared/_utils.js